"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRWebViewRTC = void 0;
var tslib_1 = require("tslib");
var Subscribe_1 = require("../shared-utils/Subscribe");
var RTCJoinedInfo_1 = require("../typings/RTCJoinedInfo");
var RTCProtocol_1 = require("../typings/RTCProtocol");
var VRWebViewRTC = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(VRWebViewRTC, _super);
    function VRWebViewRTC(_a) {
        var jsBridge = _a.jsBridge, getVoiceSign = _a.getVoiceSign;
        var _this = _super.call(this) || this;
        _this.joined = false;
        _this.micro = false;
        _this.voiceId = '';
        _this.options = { jsBridge: jsBridge, getVoiceSign: getVoiceSign };
        _this.type = RTCProtocol_1.RTCType.realsee;
        _this.jsBridge.callAndListen('live/userVolumes', function (userVolumes) {
            _this.emit('userVolumes', userVolumes);
        });
        _this.jsBridge.callAndListen('live/weakNetwork', function (weakNetwork) {
            if (weakNetwork)
                _this.emit('weakNetwork');
        });
        return _this;
    }
    Object.defineProperty(VRWebViewRTC.prototype, "jsBridge", {
        get: function () {
            return this.options.jsBridge;
        },
        enumerable: false,
        configurable: true
    });
    VRWebViewRTC.prototype.join = function (options) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var _a, sdkAppId, userId, userSig, _b, res, error;
            return (0, tslib_1.__generator)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.emit('joinWillStart');
                        return [4 /*yield*/, this.options.getVoiceSign(options)];
                    case 1:
                        _a = _c.sent(), sdkAppId = _a.sdkAppId, userId = _a.userId, userSig = _a.userSig;
                        this.type = options.type;
                        return [4 /*yield*/, this.jsBridge.callAndBackfeed("live/join?sdkAppID=" + sdkAppId + "&userID=" + userId + "&roomID=" + Number(options.voiceId) + "&userSig=" + userSig)];
                    case 2:
                        _b = _c.sent(), res = _b[0], error = _b[1];
                        if (!res) {
                            this.emit('error', error ? error : new Error('加入房间失败：未知异常。'));
                            this.joined = false;
                        }
                        else {
                            if (res.code === RTCJoinedInfo_1.RTCJoinedInfoCodeEnum.Success) {
                                this.emit('joined');
                                this.joined = true;
                            }
                            else {
                                this.emit('error', res);
                                this.joined = false;
                            }
                        }
                        return [2 /*return*/, this.joined];
                }
            });
        });
    };
    VRWebViewRTC.prototype.quit = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var _a, res, error;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.jsBridge.callAndBackfeed('live/quit')];
                    case 1:
                        _a = _b.sent(), res = _a[0], error = _a[1];
                        if (res === null) {
                            this.emit('error', error ? error : new Error('退出房间失败：未知异常。'));
                        }
                        return [2 /*return*/, !!res];
                }
            });
        });
    };
    VRWebViewRTC.prototype.detectMicro = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var _a, res, error;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.jsBridge.detectMicro()];
                    case 1:
                        _a = _b.sent(), res = _a[0], error = _a[1];
                        if (res === null) {
                            this.emit('error', error ? error : new Error('麦克风监测异常！'));
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, res];
                }
            });
        });
    };
    VRWebViewRTC.prototype.toggleMicro = function (flag) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var _a, res, error;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.jsBridge.callAndBackfeed("live/toggleMicro?flag=" + (!!flag ? 1 : 0))];
                    case 1:
                        _a = _b.sent(), res = _a[0], error = _a[1];
                        if (res === null) {
                            this.emit('error', error ? error : new Error('麦克风监测异常！'));
                            return [2 /*return*/, false];
                        }
                        this.micro = res;
                        return [2 /*return*/, res];
                }
            });
        });
    };
    VRWebViewRTC.prototype.shock = function () {
        this.jsBridge.shock(1);
    };
    return VRWebViewRTC;
}(Subscribe_1.Subscribe));
exports.VRWebViewRTC = VRWebViewRTC;
//# sourceMappingURL=VRWebViewRTC.js.map